<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "marketAnalysis",
   data(){
       return {
           
       }
   }
};
</script>

<style>
</style>